import app from 'flarum/common/app';

app.initializers.add('maisen20/local-hide-secondary-tags', () => {
  console.log('[maisen20/local-hide-secondary-tags] Hello, forum and admin!');
});
